import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentSource } from '../../models/documents/document-source.interface';
import { DefaultDocuments } from '../../models/documents/default-documents.interface';
import { shareReplay } from 'rxjs/operators';
import { ApplicationDocuments } from '@edassist/api';

@Injectable({ providedIn: 'root' })
export class DocumentsService {
	private documentTypes$: Observable<Array<DefaultDocuments>>;
	private readonly relativeUrl = 'applications/';


	constructor(private readonly http: HttpClient) {}

	getDocumentSources(): Observable<Array<DocumentSource>> {
		return this.http.get<Array<DocumentSource>>('documents/sources');
	}

	getUniqueDefaultDocuments(): Observable<Array<DefaultDocuments>> {
		if (!this.documentTypes$) {
			this.documentTypes$ = this.http
				.get<Array<DefaultDocuments>>('default-documents')
				.pipe(shareReplay(1));
		}

		return this.documentTypes$;
	}

	deleteUploadedDocuments(applicationId: string, documentId: string): Observable<void> {
		const url = `${this.relativeUrl}${applicationId}/application-documents/${documentId}`;

		return this.http.delete<void>(url);
	}
	
	fetchUploadedDocuments(applicationId: string): Observable<Array<ApplicationDocuments>> {
		const url = `${this.relativeUrl}${applicationId}/application-documents`;

		return this.http.get<Array<ApplicationDocuments>>(url);
	}
}
